import DynamicLink from 'components/DynamicLink';
import RenderInfo from 'components/RenderInfo';
import React from 'react';
import { getImageUrlFromName } from 'utils';
import styles from './index.module.scss';
import MDEditor from '@uiw/react-md-editor';
import HowItWorksSteps from 'components/HowItWorksSteps';
import FaqsForSubscription from 'components/FaqsForSubscription';

const BasicDetails = (props) => {
  const { details: { name = '', enName = '', description = '', heroText = '', howItWorksSteps = [], allowRepeatItem= false,
    howItWorksDescription = ' ', howItWorksTitle = '', successText = '', brandColor = '', subscriptionFormHeader='',
    heroImage = {}, logoImage = {}, faviconImage = {}, subscriptionBackgroundImage = {}, enDescription = '', productType = '',
    objectId = '', dynamicLink = '', faqs = [], active = false, image = {}} = {}} = props;

  const getStripeHeroProductImage = () => {
    const imageUrl = getImageUrlFromName(heroImage?.name);
    return <img src={imageUrl} className={styles['hero-image-stripe-details']} />;
  };

  const getImage = (imageHeading = 'Image', imageObject: { name: any }) => {
    const imageUrl = getImageUrlFromName(imageObject?.name);

    return (
      <RenderInfo heading={imageHeading} containerClass={styles['custom-stripe-renderinfo-container-images']} customComponent={() => (
        <img src={imageUrl} className={styles['stripe-product-image']+ ' mb-2'} />
      )} />
    );
  };

  const getSubscriptionBackgroundImage = () => {
    const imageUrl = getImageUrlFromName(subscriptionBackgroundImage?.name);
    return <img src={imageUrl} className={styles['hero-image-stripe-details']} />;
  };

  function getHowItWorksBasicDetails() {
    return (
      <div className="card mb-3">
        <div className="card-header">How It Works Basic Details</div>
        <div className="card-body">
          <label className='text-muted'>Title</label>
          <MDEditor.Markdown
            className='mb-2'
            source={howItWorksDescription}
          />
          <label className='text-muted'>Description</label>
          <MDEditor.Markdown
            source={howItWorksTitle}
          />
        </div>
      </div>
    );
  }

  function getSuccessText() {
    return (
      <div className="card mb-3">
        <div className="card-header">Subscription Success Text</div>
        <div className="card-body">
          <MDEditor.Markdown
            className='mb-2'
            source={successText}
          />
        </div>
      </div>
    );
  }

  function getSubscriptionFormHeaderText() {
    return (
      <div className="card mb-3">
        <div className="card-header">Subscription Form Header</div>
        <div className="card-body">
          <MDEditor.Markdown
            className='mb-2'
            source={subscriptionFormHeader}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles['details-section']}>
        <div className='d-flex d-sm-block'>
          {getImage('Product', image)}
          {getImage('Favicon', faviconImage)}
          {getImage('Logo', logoImage)}
        </div>
        <div className={styles['info-container']}>
          <div className={styles['info']}>
            <RenderInfo heading="ID" value={objectId} />
            <RenderInfo heading="Name" value={name} />
            <RenderInfo heading="Description" value={description} />
            <RenderInfo heading="Type" value={productType} />
            {dynamicLink && <DynamicLink link={dynamicLink} />}
            <RenderInfo heading="Brand Color" customComponent={() =>
              <input type="color" className="form-control w-50 form-control-color" id="exampleColorInput" value={brandColor} disabled />
            } />
          </div>
          <div className={styles['info']}>
            <RenderInfo heading="Active" value={active} type='boolean' />
            <RenderInfo heading="English Name" value={enName} />
            <RenderInfo heading="English Description" value={enDescription} />
            <RenderInfo heading="Allow Repeat Item" value={allowRepeatItem} type='boolean'/>
          </div>
        </div>
      </div>
      {getSuccessText()}
      {getSubscriptionFormHeaderText()}
      {getHowItWorksBasicDetails()}
      <div className={styles['details-section']}>
        <div className={styles['info-container']}>
          <div className={styles['info']}>
            <label className='label'>Hero Text</label>
            <MDEditor.Markdown source={heroText} style={{ whiteSpace: 'pre-wrap' }} />
          </div>
          <div className={styles['info']}>
            <label className='label'>Hero Image</label>
            {getStripeHeroProductImage()}
          </div>
        </div>
      </div>
      <br />
      <RenderInfo heading="Subscription Background" customComponent={getSubscriptionBackgroundImage} />
      <div className={styles['details-section']}>
        <label className='label'>How it Works? Steps</label>
        <HowItWorksSteps howItWorksSteps={howItWorksSteps} isEditor={false} />
      </div>

      <div className={styles['details-section']}>
        <label className='label'>FAQ&apos;s</label>
        <FaqsForSubscription faqs={faqs} isEditor={false} />
      </div>
    </>);
};

export default BasicDetails;